<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Badge from '../Badge';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'XmlChannelJobList',
  components: {
    Badge,
  },
  mixins: [
    dateMixin,
  ],
  props: {
    show: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Status', value: 'badge', sortable: false },
        { text: 'Import', value: 'import', sortable: false, width: '175px' },
        { text: 'Import Time', value: 'importTime', sortable: false },
        { text: 'Synchronization', value: 'sync', sortable: false, width: '175px' },
        { text: 'Synchronization Time', value: 'syncTime', sortable: false },
        { text: 'Rows', value: 'rows', sortable: false },
      ],
      formatter: new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0, minimumFractionDigits: 0 }),
    };
  },
  computed: {
    ...mapState({
      xmlJobList: state => state.xmlChannelStatus.xmlJobList,
    }),
    ...mapGetters({
      badges: 'xmlChannelStatus/getBadges',
    }),
  },
  methods: {
    ...mapActions({
      getXmlJobs: 'xmlChannelStatus/getXmlJobs',
    }),
    refreshLobList() {
      if (this.xmlJobList.loading) {
        return;
      }
      this.getXmlJobs();
    },
    getPercentProgress(xmlExport) {
      if (!xmlExport.message) {
        return '';
      }
      const match = xmlExport.message.match(/\s(\d{1,2}%)/);
      return match ? match[0] : '0%';
    },
  },
  watch: {
    show() {
      this.dialog = true;
    },
  },
};
</script>

<template>
  <v-dialog v-model="dialog" width="1000" scrollable>
    <v-flex v-if="xmlJobList.xmlChannel">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          :loading="xmlJobList.loading"
          color="primary"
          outline
        >
          {{ $t('xmlChannelStatus.xmlChannelJobList.title') }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          <span class="d-inline-block">
            {{ xmlJobList.xmlChannel.webservice }} -
            {{ xmlJobList.xmlChannel.system }} |
            {{ $t('xmlChannelStatus.xmlChannelJobList.title') }}
          </span>
          <v-btn
            @click="refreshLobList"
            :disabled="xmlJobList.loading"
            icon
          >
            <v-icon :class="{ 'icon-spin': xmlJobList.loading }">refresh</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="xmlJobList.items"
            :loading="xmlJobList.loading"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:no-data>
              <tr>
                <td v-if="!xmlJobList.loading" colspan="5" class="text-xs-center">
                  {{ $t('xmlChannelStatus.xmlChannelJobList.noContent') }}
                </td>
              </tr>
            </template>
            <template v-slot:items="job">
              <td>
                <badge
                  v-if="job.item.status === 'NO_CONTENT'"
                  :badge="badges[job.item.status]"
                  :title="$t('xmlChannelStatus.xmlChannelJobList.noJobs')"
                />
                <badge v-else :badge="badges[job.item.status]"/>
              </td>
              <td>
                {{ formatDate(job.item.runStart) }}
                <br>
                {{ formatDate(job.item.runEnd) }}
              </td>
              <td>{{ getFormattedDuration(job.item.runStart, job.item.runEnd) }}</td>
              <td>
                <template v-if="job.item.export">
                  {{ formatDate(job.item.export.startTime) }}
                  <br>
                  <template v-if="job.item.export && job.item.export.endTime">
                    {{ formatDate(job.item.export.endTime) }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td>
                <template v-if="job.item.export && job.item.export.endTime">
                  {{ getFormattedDuration(job.item.export.startTime, job.item.export.endTime) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td>{{ formatter.format(job.item.rows) }}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="dialog = false"
            color="primary"
            flat
          >
            {{ $t('general.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelJobList.vue